var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9901_2144)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 9.186V9.876C16.4991 11.4933 15.9754 13.067 15.007 14.3624C14.0386 15.6577 12.6775 16.6054 11.1265 17.0639C9.57557 17.5225 7.91794 17.4674 6.40085 16.9069C4.88376 16.3464 3.58849 15.3106 2.70822 13.9538C1.82795 12.597 1.40984 10.992 1.51626 9.37823C1.62267 7.76442 2.24791 6.22824 3.29871 4.9988C4.34951 3.76936 5.76959 2.91253 7.34714 2.55611C8.92469 2.19968 10.5752 2.36275 12.0525 3.021",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 3.87598L9 11.3835L6.75 9.13348",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9901_2144"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "currentColor",
  transform: "translate(0 0.875977)"
})))));
export default SvgCheckCircle1;